import type React from 'react';

import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { useRealtimeChatSync } from 'hooks/useRealtimeChatSync';
import { useRealtimeProfileSync } from 'hooks/useRealtimeProfileSync';
import { useRealtimeTutorBulletinsSync } from 'hooks/useRealtimeTutorBulletinsSync';
import { useGetCurrentProfile } from 'modules/Profile/model/services';
import { DesktopNotifyPrompt } from 'components/DesktopNotifyPrompt/DesktopNotifyPrompt';
import { ChatWebSocketProvider } from 'modules/ChatV2/store/ChatWebSocketContext';
import { GlobalPresenceProvider } from 'modules/ChatV2/store/GlobalPresenceContext';

const RealtimeChatSync = () => {
  useRealtimeChatSync();
  return null;
};

const RealtimeProfileAndBulletinsSync = () => {
  useRealtimeProfileSync();
  useRealtimeTutorBulletinsSync();
  return null;
};

interface RealtimeProviderProps {
  children: React.ReactNode;
}

/**
 * Единый WebSocket: сообщения, прочтение, доставка, онлайн-статус.
 */
export const RealtimeProvider: React.FC<RealtimeProviderProps> = ({ children }) => {
  const { data: session, isLoading: sessionLoading } = useAuthSession();
  const { data: profile, isLoading: profileLoading } = useGetCurrentProfile();
  const userId = profile?.id_user?.toString() ?? '';

  if (
    sessionLoading ||
    profileLoading ||
    !isAuthSessionActive(session) ||
    !userId ||
    userId === '0'
  ) {
    return <>{children}</>;
  }

  return (
    <ChatWebSocketProvider userId={userId}>
      <GlobalPresenceProvider>
        <RealtimeChatSync />
        <RealtimeProfileAndBulletinsSync />
        <DesktopNotifyPrompt />
        {children}
      </GlobalPresenceProvider>
    </ChatWebSocketProvider>
  );
};
